import React, { useState } from 'react';

/**
 * Tooltip component for displaying helpful hints on form fields
 * @param {Object} props
 * @param {React.ReactNode} props.children - Element that triggers the tooltip
 * @param {string} props.content - Tooltip text content
 * @param {string} props.position - Position of tooltip (top, right, bottom, left)
 * @param {string} props.width - Width of the tooltip (sm, md, lg, xl)
 */
const Tooltip = ({ children, content, position = 'top', width = 'md' }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Width classes
  const widthClasses = {
    sm: 'w-48',
    md: 'w-64',
    lg: 'w-80',
    xl: 'w-96'
  };

  // Position classes
  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2'
  };

  // Arrow classes
  const arrowClasses = {
    top: 'top-full left-1/2 transform -translate-x-1/2 border-t-gray-900',
    right: 'right-full top-1/2 transform -translate-y-1/2 border-r-gray-900',
    bottom: 'bottom-full left-1/2 transform -translate-x-1/2 border-b-gray-900',
    left: 'left-full top-1/2 transform -translate-y-1/2 border-l-gray-900'
  };

  return (
    <div className="relative flex items-center group">
      <div
        className="cursor-help"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
      >
        {children}
      </div>

      {isVisible && (
        <div
          className={`absolute z-50 ${positionClasses[position]} ${widthClasses[width]} bg-gray-900 text-white text-sm rounded-md shadow-lg p-3`}
          role="tooltip"
        >
          <div className={`absolute ${arrowClasses[position]} w-3 h-3 border-solid border-gray-900`}></div>
          <div>{content}</div>
        </div>
      )}
    </div>
  );
};

export default Tooltip; 